/**
 * @generated SignedSource<<417f79b8dcdad57fc2cd22dd5f1de61c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = function () {
  var v0 = [{
      "defaultValue": 30,
      "kind": "LocalArgument",
      "name": "limit"
    }],
    v1 = [{
      "kind": "Literal",
      "name": "exclude",
      "value": {
        "alertTopicNames": ["Style"]
      }
    }, {
      "kind": "Variable",
      "name": "first",
      "variableName": "limit"
    }, {
      "kind": "Literal",
      "name": "orderBy",
      "value": {
        "direction": "DESC",
        "field": "CREATED_DATE"
      }
    }],
    v2 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    },
    v3 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdDate",
      "storageKey": null
    },
    v4 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alertTopicDisplay",
      "storageKey": null
    },
    v5 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pushBody",
      "storageKey": null
    },
    v6 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    v7 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    v8 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    v9 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    v10 = [v9 /*: any*/];
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "metadata": null,
      "name": "notificationListQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": "PushNotificationConnection",
        "kind": "LinkedField",
        "name": "pushNotifications",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "PushNotificationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "PushNotification",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [v2 /*: any*/, v3 /*: any*/, v4 /*: any*/, v5 /*: any*/, v6 /*: any*/, {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "content",
              "plural": false,
              "selections": [v7 /*: any*/, {
                "kind": "InlineFragment",
                "selections": [v2 /*: any*/, v8 /*: any*/, {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "application",
                  "plural": false,
                  "selections": [v2 /*: any*/],
                  "storageKey": null
                }],
                "type": "Base",
                "abstractKey": "__isBase"
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "notificationListQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": "PushNotificationConnection",
        "kind": "LinkedField",
        "name": "pushNotifications",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "PushNotificationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "PushNotification",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [v2 /*: any*/, v3 /*: any*/, v4 /*: any*/, v5 /*: any*/, v6 /*: any*/, {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "content",
              "plural": false,
              "selections": [v7 /*: any*/, {
                "kind": "InlineFragment",
                "selections": [v2 /*: any*/, v8 /*: any*/, {
                  "alias": null,
                  "args": null,
                  "concreteType": "Application",
                  "kind": "LinkedField",
                  "name": "application",
                  "plural": false,
                  "selections": [v2 /*: any*/, v9 /*: any*/],
                  "storageKey": null
                }],
                "type": "Base",
                "abstractKey": "__isBase"
              }, {
                "kind": "InlineFragment",
                "selections": v10 /*: any*/,
                "type": "Article",
                "abstractKey": null
              }, {
                "kind": "InlineFragment",
                "selections": v10 /*: any*/,
                "type": "Video",
                "abstractKey": null
              }],
              "storageKey": null
            }, v9 /*: any*/],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "f3781571684bb447ebd7af502299dcd6",
      "id": null,
      "metadata": {},
      "name": "notificationListQuery",
      "operationKind": "query",
      "text": "query notificationListQuery(\n  $limit: Int = 30\n) {\n  pushNotifications(first: $limit, exclude: {alertTopicNames: [\"Style\"]}, orderBy: {field: CREATED_DATE, direction: DESC}) {\n    edges {\n      node {\n        entityUuid\n        createdDate\n        alertTopicDisplay\n        pushBody\n        url\n        content {\n          __typename\n          ... on Base {\n            __isBase: __typename\n            entityUuid\n            entityId\n            application {\n              entityUuid\n              id\n            }\n          }\n          ... on Article {\n            id\n          }\n          ... on Video {\n            id\n          }\n        }\n        id\n      }\n    }\n  }\n}\n"
    }
  };
}();
node.hash = "1520bd90aea861fd20c9f97504bb60b1";
export default node;